import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";

const State = Record(
  {
    isSent: false,
    form: new (Record(
      {
        loading: false,
        error: null
      },
      "form"
    ))()
  },
  "mails"
);

const mailsReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.CREATE_MAIL: {
      return state.setIn(["form", "loading"], true).setIn(["isSent"], false);
    }

    case actions.CREATE_MAIL_SUCCESS: {
      return state.setIn(["form", "loading"], false).setIn(["isSent"], true);
    }

    case actions.CREATE_MAIL_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.CREATE_MAIL_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.MAIL_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors = state.form.error &&
        state.form.error &&
        state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.MAIL_CLEAR_FORM: {
      const { clearSentStatus } = action.payload;
      if (!clearSentStatus) {
        state = state.setIn(["isSent"], false);
      }

      return state.setIn(["form", "error"], null);
    }

    default:
      return state;

  }
};

export default mailsReducer;



/** WEBPACK FOOTER **
 ** ./src/common/mails/reducer.js
 **/